<template>
  <div class="oblique-grid">
    <div class="d-flex oblique-cell">
      <ObliqueSliceViewer
        :view-id="`${viewId}-coronal`"
        outline-type="ObliqueCoronal"
        view-direction="Posterior"
        view-up="Superior"
      />
    </div>
    <div class="d-flex oblique-cell">
      <MultiObliqueSliceViewer
        :view-id="`${viewId}-multi-oblique`"
        view-direction="Posterior"
        view-up="Superior"
        :slices="[
          {
            viewID: `${viewId}-coronal`,
            axis: 'Coronal',
          },
          {
            viewID: `${viewId}-sagittal`,
            axis: 'Sagittal',
          },
          {
            viewID: `${viewId}-axial`,
            axis: 'Axial',
          },
        ]"
      />
    </div>
    <div class="d-flex oblique-cell">
      <ObliqueSliceViewer
        :view-id="`${viewId}-sagittal`"
        outline-type="ObliqueSagittal"
        view-direction="Right"
        view-up="Superior"
      />
    </div>
    <div class="d-flex oblique-cell">
      <ObliqueSliceViewer
        :view-id="`${viewId}-axial`"
        outline-type="ObliqueAxial"
        view-direction="Superior"
        view-up="Anterior"
      />
    </div>

    <PycadViewerOverlay
      class="oblique-grid__hud"
      label="OBLIQUE MPR"
      label-color="#ff9900"
      :show-slice="false"
      :show-window-level="false"
      bottom-pad="12px"
    >
      <template #bottom-right>
        <div class="pycad-view-switcher-wrapper">
          <ViewTypeSwitcher :view-id="viewId" :image-id="currentImageID" />
        </div>
      </template>
    </PycadViewerOverlay>
  </div>
</template>

<script setup lang="ts">
import MultiObliqueSliceViewer from '@/src/components/MultiObliqueSliceViewer.vue';
import ObliqueSliceViewer from '@/src/components/ObliqueSliceViewer.vue';
import useResliceCursorStore from '@/src/store/reslice-cursor';
import PycadViewerOverlay from '@/src/components/pycad/PycadViewerOverlay.vue';
import { useCurrentImage } from '@/src/composables/useCurrentImage';
import ViewTypeSwitcher from '@/src/components/ViewTypeSwitcher.vue';

interface Props {
  viewId: string;
}

defineProps<Props>();

const { currentImageID } = useCurrentImage();

useResliceCursorStore();
</script>

<style scoped src="@/src/components/styles/vtk-view.css"></style>
<style scoped src="@/src/components/styles/utils.css"></style>

<style scoped>
.oblique-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 1px;
  background-color: #2c2c2c;
  flex: 1;
}

.oblique-cell {
  min-width: 0;
  min-height: 0;
  background: #000;
}

.oblique-grid__hud {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 6;
}

.pycad-view-switcher-wrapper {
  padding: 4px;
  background: rgba(5, 5, 5, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);
}
</style>
